var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getConfigVar } from "../../utils/Configuration";
import { EmptyComponent } from "../../utils/EmptyComponent";
import { concatClassNames, excludeChildrenOfType, filterChildrenOfType } from "../../utils/Functions";
import { Alert } from "./Alert";
import { Button } from "./Button";
var Stepper = /** @class */ (function (_super) {
    __extends(Stepper, _super);
    function Stepper(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.current !== _this.props.current)
                _this.setState({ current: _this.props.current });
        };
        _this.next = function () { return _this.setState({ current: _this.state.current + 1 }); };
        _this.prev = function () { return _this.setState({ current: _this.state.current - 1 }); };
        _this.clickButton = function (props, event) {
            var action = props.action, onClick = props.onClick;
            if (action === "next")
                _this.next();
            else
                _this.prev();
            if (onClick)
                onClick(event);
        };
        _this.render = function () {
            var current = _this.state.current, children = filterChildrenOfType(_this, Step), currentStep = children[current];
            if (!currentStep)
                return React.createElement(Alert, { color: "red" }, getConfigVar("NO_MORE_STEPS"));
            var stepButtons = filterChildrenOfType(currentStep, StepperButton);
            return React.createElement("div", { className: "dolfo-stepper" },
                React.createElement("div", { className: "dolfo-stepper-header" }, children.map(function (c, i) {
                    var isVisible = children.length > 3 ? ((i >= current && i <= current + 2) ||
                        (i === children.length - 2) ||
                        (i === children.length - 3)) : true;
                    return React.createElement(React.Fragment, { key: i },
                        i > 0 && React.createElement("span", { className: current !== i ? "done" : "" }),
                        React.createElement("div", { className: concatClassNames([
                                c.props.disabled ? "disabled" : "",
                                current === i ? "current" : "",
                                !isVisible ? "hidden" : "",
                                current > i ? "done" : ""
                            ], "dolfo-stepper-step-title") },
                            current > i && React.createElement(FontAwesomeIcon, { icon: faCheck, className: "done-icon" }),
                            React.createElement("div", null, i + 1)));
                })),
                React.createElement("div", { className: "dolfo-stepper-content" },
                    excludeChildrenOfType(currentStep, StepperButton),
                    stepButtons.length > 0 && React.createElement("div", { className: "dolfo-stepper-footer" }, stepButtons.map(function (c, i) { return React.createElement(Button, __assign({}, c.props, { className: concatClassNames(c.props.className, c.props.action), onClick: function (e) { return _this.clickButton(c.props, e); }, key: i })); }))));
        };
        _this.state = {
            current: (_a = props.current) !== null && _a !== void 0 ? _a : 0
        };
        return _this;
    }
    return Stepper;
}(React.Component));
export { Stepper };
var Step = /** @class */ (function (_super) {
    __extends(Step, _super);
    function Step() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Step;
}(EmptyComponent));
export { Step };
var StepperButton = /** @class */ (function (_super) {
    __extends(StepperButton, _super);
    function StepperButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StepperButton;
}(EmptyComponent));
export { StepperButton };
